@if (score && score.currentlyServing) {
    <div class="column sets">
        <div class="cell">
            @if (score.currentlyServing === 1) {
                <span class="serving-indicator"></span>
            }
        </div>
        <div class="cell">
            @if (score.currentlyServing === 2) {
                <span class="serving-indicator"></span>
            }
        </div>
    </div>
}
@if (innings) {
    <div class="column sets">
        <div class="cell">
            @if (innings.team1.runs >= 0) {
                <div>{{ innings.team1.runs }}/{{ innings.team1.wickets }}</div>
            } @else {
                -
            }
        </div>
        <div class="cell">
            @if (innings.team2.runs >= 0) {
                <div>{{ innings.team2.runs }}/{{ innings.team2.wickets }}</div>
            } @else {
                -
            }
        </div>
    </div>
}
